export function createEmptyStock() {
    return {
        ticker: "ABCD",
        name: "Company Name",
        description: "Company Descripton",
        industry: "COMPANY INDUSTRY",
        currentPrice: 0.0,
        trailingPE: 0,
        threeYearPE: 0,
        longTermDebt: 0,
        equity: 0,
        earningsVelocity: 0,
        totalCash: 0,
        totalCashPerShare: 0,
        totalAssets: 0,
        tangibleAssets: 0,
        intangibleAssets: 0,
        priceToAssets: 0,
        debtToEquity: 0,
        dividendYield: 0.0,
        sharesOutstanding: 0,
        sentiment_range: 0,
        sentiment_avg: 0,
        sentiment_median: 0,
        // CASH FLOW METRICS
        fcfTTM: 0,
        fcfMarginTTM: 0,
        fcfToDebt: 0,
        fcfToNetIncome: 0,
        fcfTrend: 0,
        operatingCashflowTrend: 0,
        capexTrend: 0,
        fcfYoYGrowth: 0,
        // INSIDER METRICS
        insider_net_shares_1y: 0,
        insider_buys_1y: 0,
        insider_sells_1y: 0,
        insider_buy_dollar_1y: 0,
        insider_sell_dollar_1y: 0,
        // QUARTERLY INCOME STATEMENT METRICS
        revenueTTM: 0,
        grossProfitTTM: 0,
        ebitTTM: 0,
        netIncomeTTM: 0,
        grossMarginTTM: 0,
        operatingMarginTTM_Q: 0,
        netMarginTTM: 0,
        interestCoverageTTM: 0,
        revenueTrendQ: 0,
        netIncomeTrendQ: 0,
        operatingMarginTrendQ: 0,
        revenueYoYGrowthTTM: 0,
        netIncomeYoYGrowthTTM: 0,
    };
}

export function formatStockFromRaw(raw = {}) {
    const numOrZero = (value) => Number(value) || 0;
    const roundTwo = (value) => Math.round(numOrZero(value) * 100) / 100;
    const roundPercent = (value) => Math.round(numOrZero(value) * 10000) / 100;

    const totalAssets = numOrZero(raw.totalAssets);
    const intangibleAssets = numOrZero(raw.intangibleAssets);
    const tangibleAssets = totalAssets - intangibleAssets;
    const sharesOutstanding = numOrZero(raw.sharesOutstanding);
    const priceToAssetsDenom = tangibleAssets || 1;

    return {
        ticker: raw.ticker || "ABCD",
        name: raw.name || "Company Name",
        description: raw.description || "Company Descripton",
        industry: raw.industry || "COMPANY INDUSTRY",
        currentPrice: roundTwo(raw.currentPrice),
        trailingPE: roundTwo(raw.trailingPE),
        threeYearPE: roundTwo(raw.threeYearPE),
        longTermDebt: Math.round(numOrZero(raw.longTermDebt)),
        equity: Math.round(numOrZero(raw.equity)),
        earningsVelocity: roundTwo(raw.earningsVelocity),
        totalCash: Math.round(numOrZero(raw.totalCash)),
        totalCashPerShare: roundTwo(raw.totalCashPerShare),
        totalAssets: Math.round(totalAssets),
        tangibleAssets: Math.round(tangibleAssets),
        intangibleAssets: Math.round(intangibleAssets),
        priceToAssets:
            Math.round(
                ((numOrZero(raw.currentPrice) * sharesOutstanding) / priceToAssetsDenom) *
                100
            ) / 100,
        debtToEquity: roundTwo(raw.debtToEquity),
        dividendYield: roundPercent(raw.dividendYield),
        sharesOutstanding,
        sentiment_range: roundTwo(raw.sentiment_range),
        sentiment_avg: roundTwo(raw.sentiment_avg),
        sentiment_median: roundTwo(raw.sentiment_median),
        // CASH FLOW METRICS
        fcfTTM: Math.round(numOrZero(raw.fcfTTM)),
        fcfMarginTTM: roundPercent(raw.fcfMarginTTM),
        fcfToDebt: roundTwo(raw.fcfToDebt),
        fcfToNetIncome: roundTwo(raw.fcfToNetIncome),
        fcfTrend: Math.round(numOrZero(raw.fcfTrend)),
        operatingCashflowTrend: Math.round(numOrZero(raw.operatingCashflowTrend)),
        capexTrend: Math.round(numOrZero(raw.capexTrend)),
        fcfYoYGrowth: roundPercent(raw.fcfYoYGrowth),
        // INSIDER METRICS
        insider_net_shares_1y: Math.round(numOrZero(raw.insider_net_shares_1y)),
        insider_buys_1y: numOrZero(raw.insider_buys_1y),
        insider_sells_1y: numOrZero(raw.insider_sells_1y),
        insider_buy_dollar_1y: Math.round(numOrZero(raw.insider_buy_dollar_1y)),
        insider_sell_dollar_1y: Math.round(numOrZero(raw.insider_sell_dollar_1y)),
        // QUARTERLY INCOME STATEMENT METRICS
        revenueTTM: Math.round(numOrZero(raw.revenueTTM)),
        grossProfitTTM: Math.round(numOrZero(raw.grossProfitTTM)),
        ebitTTM: Math.round(numOrZero(raw.ebitTTM)),
        netIncomeTTM: Math.round(numOrZero(raw.netIncomeTTM)),
        grossMarginTTM: roundPercent(raw.grossMarginTTM),
        operatingMarginTTM_Q: roundPercent(raw.operatingMarginTTM_Q),
        netMarginTTM: roundPercent(raw.netMarginTTM),
        interestCoverageTTM: roundTwo(raw.interestCoverageTTM),
        revenueTrendQ: Math.round(numOrZero(raw.revenueTrendQ)),
        netIncomeTrendQ: Math.round(numOrZero(raw.netIncomeTrendQ)),
        operatingMarginTrendQ: roundPercent(raw.operatingMarginTrendQ),
        revenueYoYGrowthTTM: roundPercent(raw.revenueYoYGrowthTTM),
        netIncomeYoYGrowthTTM: roundPercent(raw.netIncomeYoYGrowthTTM),
    };
}

const SPECTRUM_GOOD = [90, 155, 65];   // warm sage green
const SPECTRUM_MID  = [185, 155, 45];  // golden yellow (mirrors #d4af37)
const SPECTRUM_BAD  = [200, 100, 55];  // terracotta (mirrors #cd6b3e)

const lerp = (a, b, t) => Math.round(a + (b - a) * t);

// t: 0 = worst, 1 = best
const brandColor = (t) => {
    const c = Math.max(0, Math.min(1, t));
    const [from, to, s] = c >= 0.5
        ? [SPECTRUM_MID, SPECTRUM_GOOD, (c - 0.5) * 2]
        : [SPECTRUM_BAD,  SPECTRUM_MID,  c * 2];
    return `rgb(${lerp(from[0], to[0], s)}, ${lerp(from[1], to[1], s)}, ${lerp(from[2], to[2], s)})`;
};

// Higher value = better
const scaleUp = (value, good, mid, bad) => {
    if (value >= good) return 1;
    if (value >= mid)  return 0.5 + 0.5 * (value - mid) / (good - mid);
    if (value >= bad)  return 0.5 * (value - bad) / (mid - bad);
    return 0;
};

// Lower value = better
const scaleDown = (value, good, mid, bad) => {
    if (value <= good) return 1;
    if (value <= mid)  return 0.5 + 0.5 * (mid - value) / (mid - good);
    if (value <= bad)  return 0.5 * (bad - value) / (bad - mid);
    return 0;
};

export const calculateColor = (value, type) => {
    if (type === "trailingPE" || type === "threeYearPE") {
        if (value < 0) return brandColor(0);
        return brandColor(scaleDown(value, 0, 20, 40));
    }
    if (type === "longTermDebt" || type === "equity" || type === "debtToEquity") {
        if ((type === "equity" || type === "debtToEquity") && value < 0) return brandColor(0);
        return brandColor(scaleDown(value, 0, 0.66, 3));
    }
    if (type === "earningsVelocity") {
        return brandColor(scaleUp(value, 1.5, 0, -1.5));
    }
    if (type === "priceToAssets") {
        return brandColor(scaleDown(value, 0.5, 1.2, 4));
    }
    if (type === "interestCoverage") {
        if (value < 1) return brandColor(0);
        return brandColor(scaleUp(value, 3, 2, 1));
    }
    if (type === "fcfMargin") {
        if (value < 0) return brandColor(0);
        return brandColor(scaleUp(value, 15, 5, 0));
    }
    if (type === "fcfYoYGrowth" || type === "revenueYoYGrowth" || type === "netIncomeYoYGrowth") {
        return brandColor(scaleUp(value, 50, 0, -50));
    }
    if (type === "grossMargin" || type === "operatingMargin" || type === "netMargin") {
        if (value < 0) return brandColor(0);
        return brandColor(scaleUp(value, 50, 20, 0));
    }
    if (type === "fcfToDebt") {
        if (value < 0) return brandColor(0);
        return brandColor(scaleUp(value, 0.4, 0.2, 0));
    }
    if (type === "fcfToNetIncome") {
        if (value < 0) return brandColor(0);
        return brandColor(scaleUp(value, 1, 0.5, 0));
    }
};

export const getChapterHighlightStyle = (highlight) => {
    if (!highlight) {
        return undefined;
    }
    if (highlight.ch14Success) {
        return {
            background:
                "linear-gradient(180deg, var(--highlight_gold_translucent) 0%, var(--alt_background_translucent) 100%)",
        };
    }
    if (highlight.ch15Success) {
        return {
            background:
                "linear-gradient(180deg, var(--link_color_translucent) 0%, var(--alt_background_translucent) 100%)",
        };
    }
    return undefined;
};

export function capitalizeFirstLetter(text) {
    return text.toLowerCase().replace(/(?:^|\s)\S/g, function (char) {
        return char.toUpperCase();
    });
}
